export default {
    name: "UnassignedTicketsWidget",
    description: "Displays tickets that are still not assigned to any users.",

    type: "DataWidget",
    roles: ["user", "manager"],
    widget: {
        title: "Unassigned Tickets Queue",
        dataProvider: {
            main: {
                rpc: "ManagerDashboardRpc.getUnassignedTickets",
                transform: (response) => response?.data || []
            }
        },
        itemAction: {
            type: 'navigate',
            route: '/user/tickets?ticketId={{_id}}'
        },
        itemTemplate: (item) => {
            const statusStyles = {
                'new': { color: 'danger', text: 'New' },
                'pending': { color: 'warning', text: 'Pending' },
                'open': { color: 'info', text: 'Open' }
            };
            const status = statusStyles[item.status] || { color: 'secondary', text: item.status };
            const creationDate = new Date(item.createdAt).toLocaleDateString([], { month: 'short', day: 'numeric' });

            return `
                <style>
                    .unassigned-ticket-card { padding: 0.75rem; border-left: 4px solid var(--bs-${status.color}); background-color: var(--bs-tertiary-bg); border-radius: var(--bs-border-radius); margin-bottom: 0.5rem; }
                </style>
                <div class="unassigned-ticket-card">
                    <div class="d-flex justify-content-between align-items-start">
                        <div class="flex-grow-1">
                            <div class="fw-bold"><span class="text-muted">#${item.ticketNumber}</span> - ${item.subject}</div>
                            <small class="text-muted">Created: ${creationDate}</small>
                        </div>
                        <div class="text-nowrap ms-3">
                             <span class="badge bg-${status.color}">${status.text}</span>
                        </div>
                    </div>
                </div>
            `;
        },
        noDataMessage: "The unassigned ticket queue is empty."
    }
};
